/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_BookableInputs */

const en_admin_resource_form_bookable = /** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookable`)
};

const de_admin_resource_form_bookable = /** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchbar`)
};

const es_admin_resource_form_bookable = /** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservable`)
};

const fr_admin_resource_form_bookable = /** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservable`)
};

const nl_admin_resource_form_bookable = /** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveerbaar`)
};

/** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */
const it_admin_resource_form_bookable = en_admin_resource_form_bookable;

/** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */
const pt_br2_admin_resource_form_bookable = en_admin_resource_form_bookable;

/** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */
const pl_admin_resource_form_bookable = en_admin_resource_form_bookable;

/** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */
const hu_admin_resource_form_bookable = en_admin_resource_form_bookable;

/** @type {(inputs: Admin_Resource_Form_BookableInputs) => LocalizedString} */
const ro_admin_resource_form_bookable = en_admin_resource_form_bookable;

/**
* | output |
* | --- |
* | "Bookable" |
*
* @param {Admin_Resource_Form_BookableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_bookable = /** @type {((inputs?: Admin_Resource_Form_BookableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_BookableInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_bookable(inputs)
	if (locale === "de") return de_admin_resource_form_bookable(inputs)
	if (locale === "es") return es_admin_resource_form_bookable(inputs)
	if (locale === "fr") return fr_admin_resource_form_bookable(inputs)
	if (locale === "nl") return nl_admin_resource_form_bookable(inputs)
	if (locale === "it") return it_admin_resource_form_bookable(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_bookable(inputs)
	if (locale === "pl") return pl_admin_resource_form_bookable(inputs)
	if (locale === "hu") return hu_admin_resource_form_bookable(inputs)
	return ro_admin_resource_form_bookable(inputs)
});
export { admin_resource_form_bookable as "admin.resource_form.bookable" }